import createTheme from '@material-ui/core/styles/createTheme';
import {
  lightGrey, white, green, blue, cyan, grey, red, yellow,
} from './colors';

const theme = createTheme({
  colors: {
    lightGrey,
    white,
    green,
    blue,
    cyan,
    grey,
    red,
    yellow,
  },
  typography: {
    // phone sizes for the display headings; desktop keeps the MUI defaults
    h4: {
      '@media (max-width:600px)': {
        fontSize: '1.5rem',
      },
    },
    h5: {
      '@media (max-width:600px)': {
        fontSize: '1.125rem',
      },
    },
  },
});

export default theme;
